"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./RadioField.css");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
    Radio field
    
    A radio button with label

    Verified by: Yorben Verhoest
    Date: 06/12/2019
    identityBuilding bvba
    https://identitybuilding.be
*/
// Our main component
var RadioField = function RadioField(props) {
  return /*#__PURE__*/_react["default"].createElement("label", {
    className: "radioField ".concat(props.className ? props.className : '', " ").concat(props.checked ? 'active' : '', " ").concat(props.disabled ? 'disabled' : ''),
    htmlFor: "radioField".concat(props.name ? props.name : '')
  }, /*#__PURE__*/_react["default"].createElement("input", {
    "aria-label": props.label,
    disabled: props.disabled,
    id: "radioField".concat(props.name ? props.name : ''),
    name: props.group,
    type: "radio",
    checked: props.checked,
    onChange: function onChange(e) {
      return props.onChange(e.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "radioFieldBox"
  }), props.label && /*#__PURE__*/_react["default"].createElement("span", null, props.label));
};

var _default = RadioField;
exports["default"] = _default;